module.exports = __webpack_public_path__ + "static/media/no_dishes.6d358a4a.svg";